const initialState = true;

const showAllSubtasksReducer = (state = initialState, action) => {
  if (action.type === 'TOGGLE_SHOW_ALL_SUBTASKS') {
    return !state;
  }
  return state;
};

export default showAllSubtasksReducer;